import type { NoteDTO } from "../../../api/api";
import { przezmorzeApi, throwMessageOnBadRequestStatus } from "../../../api/api";
import type { Agent, AgentListResponse, CreateOrUpdateAgentRequest, Department } from "@przezmorze/api-types";

export type { Department, CreateOrUpdateAgentRequest };
export type AgentResponse = Agent;

export async function listAgents(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<AgentListResponse>("/agents", {
    signal: abortSignal,
  });
  return response.data.items;
}

export async function getAgent(agentId: string, abortSignal?: AbortSignal) {
  if (!agentId) {
    return null;
  }
  const response = await przezmorzeApi.get<AgentResponse>(`/agents/${agentId}`, {
    signal: abortSignal,
  });
  return response.data;
}

export async function createAgent(request: CreateOrUpdateAgentRequest, abortSignal?: AbortSignal) {
  try {
    const response = await przezmorzeApi.post<AgentResponse>("/agents", request, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnBadRequestStatus(error);
  }
}

export async function updateAgent(agentId: string, request: CreateOrUpdateAgentRequest, abortSignal?: AbortSignal) {
  try {
    const response = await przezmorzeApi.put<AgentResponse>(`/agents/${agentId}`, request, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnBadRequestStatus(error);
  }
}

export async function deleteAgent(agentId: string, abortSignal?: AbortSignal) {
  await przezmorzeApi.delete(`/agents/${agentId}`, {
    signal: abortSignal,
  });
}

export async function updateAgentNotes(
  agentId: string,
  notes: NoteDTO[],
  abortSignal?: AbortSignal,
): Promise<AgentResponse> {
  const response = await przezmorzeApi.put<AgentResponse>(
    `/agents/${agentId}/notes`,
    { notes },
    {
      signal: abortSignal,
    },
  );
  return response.data;
}
